// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"styles_layoutWrapper__eAUr2"};